import {
  BarChart3, Users, Package, Briefcase,
  MessageSquare, Calendar, Database, Settings,
  Layers, FileText, Table, Map, Smile,
  Mail, Lock, AlertCircle, Coins
} from 'lucide-react';

export const menuGroups = [
  {
    label: 'Menu',
    items: [
      {
        path: '#dashboard-layout', label: 'Dashboard', icon: Layers, sub: [
          { path: '/dashboard-analytics', label: 'Analytics' },
          { path: '/dashboard-crypto', label: 'Crypto' },
          { path: '/', label: 'Ecommerce' },
          { path: '/dashboard-hrms', label: 'Hrms' },
          { path: '/dashboard-job', label: 'Job' },
        ]
      },
    ]
  }, {
    label: 'Pages',
    items: [
      {
        path: '#auth-layout', label: 'Authentication', icon: Lock, sub: [
          { path: '/login', label: 'Login' },
          { path: '/register', label: 'Register' },
          { path: '/forgot-password', label: 'Forgot Password' },
          { path: '/reset-password', label: 'Reset Password' },
          { path: '/two-factor', label: 'Two Factor' },
          { path: '/lock-screen', label: 'Lock Screen' }
        ]
      },
      {
        path: '#error-layout', label: 'Error Pages', icon: AlertCircle, sub: [
          { path: '/404', label: '404 Error' },
          { path: '/403', label: '403 Forbidden' },
          { path: '/500', label: '500 Server Error' }
        ]
      },
      {
        path: '/starter', label: 'Starter Page', icon: FileText
      }
    ]
  },
  {
    label: 'Apps',
    items: [
      { path: '/messages', label: 'Chat', icon: MessageSquare },
      { path: '/calendar', label: 'Calendar', icon: Calendar },
      { path: '/email', label: 'Email', icon: Mail },
      {
        path: '#crypto-layout', label: 'Crypto App', icon: Coins, sub: [
          { path: '/apps/crypto/market', label: 'Market Prices' },
          { path: '/apps/crypto/trade', label: 'Swap & Trade' },
          { path: '/apps/crypto/staking', label: 'DeFi Staking' },
          { path: '/apps/crypto/transactions', label: 'Transactions' },
        ]
      },
      {
        path: '#ecommerce-layout', label: 'Ecommerce', icon: Layers, sub: [
          { path: '/apps/ecommerce/products', label: 'Products' },
          { path: '/apps/ecommerce/create', label: 'Create Product' },
          { path: '/apps/ecommerce/cart', label: 'Cart' },
          { path: '/apps/ecommerce/checkout', label: 'Checkout' },
          { path: '/apps/ecommerce/wishlist', label: 'Wishlist' },
          { path: '/apps/ecommerce/orders', label: 'Orders Ledger' }
        ]
      },
      {
        path: '#hrms-layout', label: 'HRMS', icon: Users, sub: [
          { path: '/apps/hrms/dashboard', label: 'Directory' },
          { path: '/apps/hrms/attendance', label: 'Attendance' },
          { path: '/apps/hrms/leaves', label: 'Leave Claims' },
          { path: '/apps/hrms/payroll', label: 'Payroll' },
          { path: '/apps/hrms/onboarding', label: 'Onboarding' },
          { path: '/apps/hrms/departments', label: 'Divisions' },
          { path: '/apps/hrms/calendar', label: 'Holidays' },
          { path: '/apps/hrms/create', label: 'Add Staff' }
        ]
      },
      {
        path: '#jobs-layout', label: 'Job Portal', icon: Briefcase, sub: [
          { path: '/apps/jobs/dashboard', label: 'Job Positions' },
          { path: '/apps/jobs/candidates', label: 'Candidates' },
          { path: '/apps/jobs/tracker', label: 'Pipeline Tracker' },
          { path: '/apps/jobs/scheduler', label: 'Interviews' },
          { path: '/apps/jobs/referrals', label: 'Referrals Board' },
          { path: '/apps/jobs/analytics', label: 'Funnel Analytics' },
          { path: '/apps/jobs/create', label: 'Post Job' }
        ]
      },
      { path: '/users', label: 'Users', icon: Users },
    ]
  },
  {
    label: 'Components',
    items: [
      {
        path: '#basic-ui', label: 'Basic UI Elements', icon: Package, sub: [
          { path: '/components/alert', label: 'Alert' },
          { path: '/components/avatar', label: 'Avatar' },
          { path: '/components/badge', label: 'Badge' },
          { path: '/components/breadcrumb', label: 'Breadcrumb' },
          { path: '/components/button', label: 'Button' },
          { path: '/components/collapsible', label: 'Collapsible' },
          { path: '/components/dialog', label: 'Dialog' },
          { path: '/components/dropdown-menu', label: 'Dropdown Menu' },
          { path: "/components/list", label: "List" },
          { path: "/components/link", label: "Link" },
          { path: "/components/ribbons", label: "Ribbons" },
          { path: "/components/utilities", label: "Utilities" },
          { path: "/components/embedded-video", label: "Embedded Video" },
          { path: "/components/legend", label: "Legend" },
          { path: '/components/navbars', label: 'Navbars' },
          { path: '/components/pagination', label: 'Pagination' },
          { path: '/components/popover', label: 'Popover' },
          { path: '/components/progress', label: 'Progress' },
          { path: '/components/separator', label: 'Separator' },
          { path: '/components/sheet', label: 'Sheet' },
          { path: '/components/skeleton', label: 'Skeleton' },
          { path: '/components/slider', label: 'Slider' },
          { path: '/components/tabs', label: 'Tabs' },
          { path: '/components/toggle', label: 'Toggle' },
          { path: '/components/tooltip', label: 'Tooltip' },
          { path: '/components/typography', label: 'Typography' },
        ]
      },
      {
        path: '#advanced-ui', label: 'Advanced UI', icon: Layers, sub: [
          { path: '/components/accordion', label: 'Accordion' },
          { path: '/components/alert-dialog', label: 'Alert Dialog' },
          { path: '/components/aspect-ratio', label: 'Aspect Ratio' },
          { path: "/components/block-ui", label: "Block UI" },
          { path: '/components/combobox', label: 'Combobox' },
          { path: '/components/command', label: 'Command' },
          { path: "/components/counter-up", label: "Counter Up" },
          { path: "/components/drag-drop", label: "Drag & Drop" },
          { path: '/components/list-group', label: 'List Group' },
          { path: '/components/media-object', label: 'Media Object' },
          { path: "/components/ratings", label: "Ratings" },
          { path: '/components/spinner', label: 'Spinner' },
          { path: "/components/sweet-alert", label: "Sweet Alert" },
          { path: "/components/swiper", label: "Swiper Slider" },
          { path: "/components/toast", label: "Toast" },
          { path: "/components/tour", label: "Tour" },
          { path: "/components/tree", label: "Tree" },
          { path: "/components/watermark", label: "Watermark" },
        ]
      },
      {
        path: '#form-elements', label: 'Form Elements', icon: FileText, sub: [
          { path: '/forms', label: 'Advance Form' },
          { path: '/components/checkbox', label: 'Checkbox' },
          { path: '/components/date-picker', label: 'Date Picker' },
          { path: '/components/radio-group', label: 'Radio Group' },
          { path: '/components/input', label: 'Input' },
          { path: '/components/input-group', label: 'Input Group' },
          { path: '/components/input-otp', label: 'Input OTP' },
          { path: '/components/label', label: 'Label' },
          { path: '/components/native-select', label: 'Native Select' },
          { path: '/components/resizable', label: 'Resizable' },
          { path: '/components/select', label: 'Select' },
          { path: '/components/switch', label: 'Switch' },
          { path: '/components/textarea', label: 'Textarea' },
        ]
      },
      {
        path: '/tables', label: 'Tables', icon: Table, sub: [
          { path: '/tables', label: 'Basic Tables' },
          { path: '/components/grid-js', label: 'Grid.js Tables' },
        ]
      },
      {
        path: '#charts', label: 'Charts', icon: BarChart3, sub: [
          { path: '/components/charts', label: 'ApexCharts' },
          { path: '/components/chartjs', label: 'Chart.js' },
          { path: '/components/echarts', label: 'ECharts' },
        ]
      },
      {
        path: '/components/leaflet-maps', label: 'Maps', icon: Map, sub: [
          { path: '/components/leaflet-maps', label: 'Leaflet Maps' },
          { path: '/components/vector-maps', label: 'Vector Maps' },
          { path: '/components/google-maps', label: 'Google Maps' },
        ]
      },
      {
        path: '/components/lucide-icons', label: 'Icons', icon: Smile, sub: [
          { path: '/components/lucide-icons', label: 'Lucide Icons' },
          { path: '/components/remix-icons', label: 'Remix Icons' },
          { path: '/components/font-awesome', label: 'Font Awesome' },
        ]
      },
    ]
  },
  {
    label: 'Settings',
    items: [
      { path: '/settings', label: 'Settings', icon: Settings },
      { path: '/database', label: 'Database', icon: Database },
    ]
  },
  {
    label: 'Extra',
    items: [
      {
        path: '#multi-level', label: 'Multi Level Menu', icon: Layers, sub: [
          { path: '#', label: 'Level 1.1' },
          {
            path: '#level-1-2', label: 'Level 1.2', sub: [
              { path: '#', label: 'Level 2.1' },
              { path: '#', label: 'Level 2.2' }
            ]
          }
        ]
      },
    ]
  }
];
